<template>
  <div class="p-4">
    <div>
      <div class="text-center">
        <h1>Thank you for contacting us,​</h1>
        <h1>We will get back to you shortly.</h1>
      </div>
      <div class="text-center p-2">
        <button
          class="px-10 bg-053c6d text-white rounded-lg fsize10 py-2"
          @click="handleSubmit()"
          id="thankyouforsubmition"
          download
        >
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      handleSubmit() {
        this.$router.push({ name: "Home" });
        this.$emit("closeModal", true);
      },
    };
  },
  methods: {},
};
</script>

<style>
.bg-053c6d {
  background: #053c6d;
}
.btn-secondary:hover {
  background-color: none !important;
}
</style>
